import { Component } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'my-app',
  templateUrl: './app.component.html',
  styleUrls: ['../style.scss',]
})

export class AppComponent {
  session = localStorage.getItem('jiraSession')

  logout() {
    this.authService.logout();
    this.router.navigate(['/Login']);
  }

  constructor(public authService: AuthService, public router: Router) {
  }

  ngOnInit() {
  }

}
